export const enum FrameMessage {
  PlasmicHostRegister = "PLASMIC_HOST_REGISTER",
  StudioFrameLoaded = "STUDIO_FRAME_LOADED",
}
